import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { form } from '../../atoms/Forms'
import style from './style.css'
import Loading from '../../atoms/Loading'


import Button from '../../atoms/Button'
import Avatar from '../../atoms/Avatar'

import T from '../../../SPRINTA/translate/T'

import * as discussion from '../../../utils/discussion.js'

class ResponseForum extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: {
                text:''
            },
            status: 'done'
        }
    }

    handleChange = (event) => {
        this.setState( form(this.state.form, event.target) )
    }
    handleSubmit = (e) => {
        e.preventDefault()
        this.setState({
            ...this.state,
            status: 'loading'
        })

        discussion.newAnswer(this.props.question, this.state.form.text).then(resp => {
            var date = new Date()
            this.props.handleAdd({
                id: resp.id,
                content: this.state.form.text,
                question: this.props.question,
                create_at: `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`,
            })

            this.setState({
                ...this.state,
                status: 'done',
                form: {
                    text: ''
                }
            })

        })
    }

    render() {
        const { show } = this.props;
        return (
        <div className={`${style.responsewrap}`}>
            <form className={`${style.response}`} style={{ display: (show ? 'inline-block' : 'none') }} onSubmit={this.handleSubmit}>
                <div className={`${style.avatarwrap}`}>
                    <Avatar size={35} img={`${this.props.login.user.avatar ? `${window.URL_ASSETS_BASE}${this.props.login.user.avatar}` : ''}`} />
                </div>
                <h4>{this.props.login.user.name}</h4>
                <textarea placeholder={T.txt('response_this_question')} name='text' onChange={this.handleChange} value={this.state.form.text} disabled={(this.state.status === 'done' ? false : true)}/>
                
                <Button inline color="orange" disabled={this.state.form.text.length === 0  && this.state.status === 'done'}>
                    {(this.state.status === 'loading') ? (
                        <Loading
                            color='#fff'
                            size='30px' />
                    ) : <span className={style.btnwhite}>{T.text('comment')}</span>}
                </Button>
                {this.props.handleClose && (
                    <Button type="button" inline onClick={() => this.props.handleClose()}>{T.text('back')}</Button>
                )}
            </form>
        </div>
        )
    }
}
 
const mapStateToProps = state => ({
    login: state.login
})
const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)
  
export default connect(mapStateToProps, mapDispatchToProps)(ResponseForum)


// WEBPACK FOOTER //
// ./src/components/molecules/ResponseForum/index.js